/* Native Afterpay on-site messaging — replaces the Afterpay app block.
   Recomputes the per-installment amount (price / 4) on variant change by
   reading the variant JSON embedded in <variant-selects>/<variant-radios>. */
(function () {
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var pattern = format && format.length ? format : '${{amount}}';

    function thousand(num, dec, thousands, decimal) {
      dec = dec == null ? 2 : dec;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(num) || num == null) return '0';
      var n = (Math.abs(cents) / 100.0).toFixed(dec);
      var parts = n.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var rest = parts[1] ? decimal + parts[1] : '';
      return dollars + rest;
    }

    var re = /\{\{\s*(\w+)\s*\}\}/;
    var match = pattern.match(re);
    var key = match ? match[1] : 'amount';
    var value;
    switch (key) {
      case 'amount_no_decimals': value = thousand(cents, 0); break;
      case 'amount_with_comma_separator': value = thousand(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = thousand(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = thousand(cents, 2, ' ', '.'); break;
      case 'amount_with_apostrophe_separator': value = thousand(cents, 2, "'", '.'); break;
      default: value = thousand(cents, 2); break;
    }
    return pattern.replace(re, value);
  }

  class AfterpayMessage extends HTMLElement {
    connectedCallback() {
      this.amountEl = this.querySelector('[data-afterpay-amount]');
      this.format = this.dataset.moneyFormat;
      this.section = this.dataset.section;
      var scope = this.closest('section') || document;
      this.variantSelects = scope.querySelector('variant-selects, variant-radios');
      // The native bundle deal owns the variant picker (no variant-selects),
      // so fall back to its embedded variant JSON when present.
      this.bundleDeal = scope.querySelector('bundle-deal');
      this.input =
        document.querySelector('#product-form-' + this.section + ' input[name="id"]') ||
        (this.variantSelects && this.variantSelects.querySelector('input[name="id"]'));
      if (this.input) {
        this._handler = this.update.bind(this);
        this.input.addEventListener('change', this._handler);
      }
    }

    disconnectedCallback() {
      if (this.input && this._handler) this.input.removeEventListener('change', this._handler);
    }

    variants() {
      if (this._variants !== undefined) return this._variants;
      this._variants = null;
      var source = this.variantSelects
        ? this.variantSelects.querySelector('script[type="application/json"]')
        : (this.bundleDeal && this.bundleDeal.querySelector('script[data-bundle-variants]'));
      if (source) {
        try { this._variants = JSON.parse(source.textContent); } catch (e) { /* noop */ }
      }
      return this._variants;
    }

    update() {
      if (!this.amountEl || !this.input) return;
      // When the bundle deal owns the buy area, mirror its selected total
      // (Buy 2/3, sub-aware) instead of a single unit, and hide afterpay for
      // subscriptions since Afterpay can't fund a recurring order.
      if (this.bundleDeal) {
        if (this.bundleDeal.dataset.afterpaySubscribed === '1') {
          this.style.display = 'none';
          return;
        }
        this.style.display = '';
        var total = parseInt(this.bundleDeal.dataset.afterpayCents, 10);
        if (!isNaN(total) && total > 0) {
          this.amountEl.textContent = formatMoney(Math.round(total / 4), this.format);
          return;
        }
      }
      var id = parseInt(this.input.value, 10);
      var variants = this.variants();
      if (!variants) return;
      var v = variants.find(function (x) { return x.id === id; });
      if (!v) return;
      var per = Math.round(v.price / 4);
      this.amountEl.textContent = formatMoney(per, this.format);
    }
  }

  if (!customElements.get('afterpay-message')) {
    customElements.define('afterpay-message', AfterpayMessage);
  }
})();
